import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Slider.css"; // Custom CSS
import Slide1 from "../Images/slide1.webp";
import Slide2 from '../Images/slide2.webp';
import Slide3 from '../Images/slide3.webp';
import Slide4 from '../Images/slide4.webp';
import Slide5 from '../Images/slide5.jpeg';

const Slider = () => {
  const profiles = [
    {
      beforeImg: Slide1,
      afterImg: Slide1,
      name: "Shaniqua",
      posts: "120",
      followers: "30.6k",
      following: "203",
      posts2:"200",
      followers2: "35.7k",
      following2:"500",
    },
    {
      beforeImg: Slide2,
      afterImg: Slide2,
      name: "Emily Carter",
      posts: "98",
      followers: "25.2k",
      following: "180",
      posts2:"150",
      followers2: "35.7k",
      following2:"400",
    },
    {
      beforeImg: Slide3,
      afterImg: Slide3,
      name: "joan deo",
      posts: "150",
      followers: "45.3k",
      following: "320",
      posts2:"200",
      followers2: "52.4k",
      following2:"520",
    },
    {
        beforeImg: Slide4,
        afterImg: Slide4,
        name: "jony",
        posts: "150",
        followers: "45.3k",
        following: "320",
        posts2:"200",
      followers2: "49.7k",
      following2:"480",
      },
      {
        beforeImg: Slide5,
        afterImg: Slide5,
        name: "Prince",
        posts: "150",
        followers: "45.3k",
        following: "320",
        posts2:"200",
      followers2: "58.6k",
      following2:"500",
      },
      {
        beforeImg: Slide2,
        afterImg: Slide2,
        name: "Emily Carter",
        posts: "150",
        followers: "45.3k",
        following: "320",
        posts2:"220",
      followers2: "50.7k",
      following2:"560",
      },    
  ];

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Client Reviews</h2>
      <OwlCarousel
        className="owl-theme"
        loop
        margin={20}
        nav={false}
        dots={true}
        autoplay={true}
        autoplayTimeout={2000}
        responsive={{
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 3 },
        }}
      >
        {profiles.map((profile, index) => (
          <div key={index} className="profile-container">
            {/* Before Card */}
            <div className="before-card">
              <h4>Before</h4>
              <img src={profile.beforeImg} alt="Before" className="profile-img" />
              <div className="profile-info">
                <h5>{profile.name}</h5>
                <p className="slidepara"><strong>{profile.posts}</strong> Posts</p>
                <p className="slidepara"><strong>{profile.followers}</strong> Followers</p>
                <p className="slidepara"><strong>{profile.following}</strong> Following</p>
              </div>
            </div>

            {/* After Card */}
            <div className="after-card">
              <h4>After</h4>
              <img src={profile.afterImg} alt="After" className="profile-img" />
              <div className="profile-info">
                <h5>{profile.name}</h5>
                <p className="slidepara"><strong>{profile.posts2}</strong> Posts</p>
                <p className="slidepara"><strong>{profile.followers2}</strong> Followers</p>
                <p className="slidepara"><strong>{profile.following2}</strong> Following</p>
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
};

export default Slider;
